var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72852 0.75H15.7002C15.8588 0.750056 15.9766 0.81837 16.0312 0.884766C16.0777 0.941358 16.0773 0.987974 16.0635 1.02441L12.0693 11.5078C11.9816 11.7382 12.0126 11.9971 12.1523 12.2002C12.2923 12.4033 12.5238 12.5254 12.7705 12.5254H21.3076C21.5005 12.5256 21.6215 12.6222 21.6602 12.6914C21.6776 12.7227 21.6802 12.7487 21.6777 12.7695C21.6751 12.7909 21.6649 12.8231 21.6318 12.8604L5.93164 30.5225C5.83387 30.6324 5.60374 30.699 5.40039 30.6064C5.31042 30.5655 5.26676 30.5107 5.24902 30.4736C5.23272 30.4394 5.23225 30.4099 5.24316 30.3789L9.28223 18.8926C9.36292 18.6631 9.32713 18.4085 9.18652 18.21C9.04591 18.0115 8.81742 17.8936 8.57422 17.8936H1.12109C0.966108 17.8935 0.850041 17.8282 0.793945 17.7627C0.745227 17.7057 0.745387 17.6593 0.756836 17.625L6.36328 0.943359C6.38444 0.880424 6.49792 0.750023 6.72852 0.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.6f1106d3389d3f6b7f37cad716f1fe12.svg";
export { ForwardRef as ReactComponent };